import { SandpackPreview } from "@codesandbox/sandpack-react";
import { styled } from "@stitches/react";

const PreviewContainer = styled("div", {
  width: "100%",
  height: "100%",

  ".sp-preview-container, iframe": {
    width: "100%",
    height: "100%",
  },

  iframe: {
    border: "1px solid #ccc",
    padding: " 0",
    margin: "0",
    background: "#fff",
  },
});

function Preview({ ...props }) {
  return (
    <PreviewContainer {...props}>
      <SandpackPreview
        viewportSize={{ width: "100%", height: "100%" }}
        showRefreshButton={false}
        showOpenInCodeSandbox={false}
      />
    </PreviewContainer>
  );
}

export default Preview;
